export default __webpack_public_path__ + "static/media/chapas-detalle.86cbc50f.png";